import script from "./DocNav.vue?vue&type=script&setup=true&lang=js"
export * from "./DocNav.vue?vue&type=script&setup=true&lang=js"

import "./DocNav.vue?vue&type=style&index=0&id=3db16fba&lang=scss"

const __exports__ = script;

export default __exports__